// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"aabbdb76","133":"30dd2b0c","182":"1716da06"}[chunkId] + ".chunk.js";
};